import React from "react";
import { STATUS, pillColor } from "@/lib/format";

export function StatusPill({ status, testid }) {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`}>
      {s.label}
    </span>
  );
}

export function ColorPill({ color, children }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${pillColor[color] || pillColor.green}`}>
      {children}
    </span>
  );
}

export function ProgressBar({ pct, color }) {
  const c = { green: "#3E8755", amber: "#F29C38", red: "#D94E4E" }[color] || "#3E8755";
  return (
    <div className="w-full h-2 rounded-full bg-slate-100 overflow-hidden">
      <div className="h-full rounded-full transition-all duration-500" style={{ width: `${Math.min(pct, 100)}%`, background: c }} />
    </div>
  );
}
